// extracted by mini-css-extract-plugin
module.exports = {"custom-toggle":"Style_custom-toggle__32kGD","dropdownMenu":"Style_dropdownMenu__3JYYf"};